<template>
  <m-form-row data-cy="complements-interactive-list--form-row">
    <m-interactive-list
      data-cy="complements-interactive-list"
      v-model="complementsList"
      :addButtonText="$t('offer-manager.create.step-complements.lbl-add-complement')"
      :emptyListText="$t('offer-manager.create.step-complements.lbl-no-complements')"
      @addNewItem="addComplement"
      :max="15 - packsList.length"
      :disabled="disabled">
      <template #list-item="{item, index}">
        <div class="py-1 d-flex">
          <mapit-input
            class="col-4 pl-0 py-0"
            :uid="`complement${index}name`"
            :type="InputTypes.TEXT_FIELD_WITH_SUGGESTIONS"
            :value="item.name"
            :placeholder="$t('offer-manager.create.step-complements.lbl-complement-placeholder')"
            @changeValue="value => updateOffer('SET_COMPLEMENT_NAME', {name: value, index})"
            :hideDetails="true"
            :maxlength="100"
            :listItems="complementSuggestions"
            :disabled="disabled" />
          <price-field
            :data-cy="`complement${index}tariff`"
            class="col-3 pl-0 py-0"
            :placeholder="$t('offer-manager.create.step-complements.lbl-tariff-placeholder')"
            :value="item.price"
            @input="value => setComplementPrice(item, value, index)"
            :disabled="disabled"
            @change="value => setComplementPrice(item, value, index)" />
          <discount-field
            class="col-3 pl-0 py-0"
            :uid="`complement${index}discount`"
            :valueCurrency="item.discount"
            :valuePercentage="item.discountPercent"
            :placeholder="$t('offer-manager.create.step-vehicle-registration.lbl-discount-placeholder')"
            @changeValueCurrency="value => updateOffer('SET_COMPLEMENT_DISCOUNT', {discount: parseFloat(value), index})"
            @changeValuePercentage="
              value => updateOffer('SET_COMPLEMENT_DISCOUNT_PERCENT', {discount: parseFloat(value), index})
            "
            :disabled="!item.price || disabled"
            :rulesPercentage="complementDiscountRulesPercentage"
            :rulesCurrency="complementDiscountRules"
            :maxCurrency="item.price"
            @validateForm="validateForm" />
          <price-field
            :data-cy="`complement${index}price`"
            class="col-2 p-0"
            :placeholder="$t('offer-manager.create.step-complements.lbl-price-placeholder')"
            :key="item.getTotalPrice()"
            :value="parseFloat(item.getTotalPrice().toFixed(2))"
            readonly />
        </div>
      </template>
    </m-interactive-list>
  </m-form-row>
</template>

<script lang="ts">
import {Complement, Complements} from '@muvio/honda-offers-builder/model'
import {computed, defineComponent} from '@vue/composition-api'

import DiscountField from '@/components/general/DiscountField.vue'
import MapitInput from '@/components/general/MapitInput.vue'
import PriceField from '@/components/general/PriceField.vue'
// @ts-ignore
import {complementDiscountRules, complementDiscountRulesPercentage} from '@/helpers/offer-manager-rules'
import {InputTypes} from '@/utils/constants'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'Complements',
  components: {MapitInput, DiscountField, PriceField},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {root, emit}) {
    const {
      getPacks: packsList,
      getComplementsTotalPrice: complementsTotal,
      getComplementSuggestions: complementSuggestions,
    } = mapGetters(root.$store.getters)

    const complementsList = computed({
      // TODO: replace on change vue3
      get: (): Complements | undefined => root.$store.getters.getComplements,
      set: (value: Complements | undefined) => root.$store.commit('SET_COMPLEMENTS', value),
    })

    function validateForm() {
      emit('validateForm')
    }

    function addComplement() {
      root.$store.dispatch('addComplement')
      validateForm()
    }

    function updateOffer(mutation: string, value: any) {
      root.$store.commit(mutation, value)
      validateForm()
    }

    function setComplementPrice(item: Complement, value: string, index: number) {
      if (item.price !== parseFloat(value)) {
        // The m-price-field edits the value with a mask. Only modify if the value changes... sample 50,00 === 50.00
        updateOffer('SET_COMPLEMENT_PRICE', {price: parseFloat(value), index})
      }
    }

    return {
      InputTypes,
      complementDiscountRules,
      complementDiscountRulesPercentage,
      complementsList,
      packsList,
      complementsTotal,
      complementSuggestions,
      setComplementPrice,
      addComplement,
      validateForm,
      updateOffer,
    }
  },
})
</script>
